import { SafeAreaBottomKeyboardData, SafeAreaData, SafeAreaInsetData } from '../../../capacitor_plugins/safeArea';

const createSafeAreaSingleton = () => {
    let safeArea = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
    };

    let safeAreaKeyboard = {
        offset: 0,
        padding: 0,
    };

    return {
        setSafeAreaData: (newSafeAreaData: SafeAreaData) => {
            safeArea = newSafeAreaData.safeAreaInsets;
            safeAreaKeyboard = newSafeAreaData.safeAreaKeyboard;
        },
        getSafeArea: (): SafeAreaInsetData => safeArea,
        getSafeAreaKeyboard: (): SafeAreaBottomKeyboardData => safeAreaKeyboard,
    };
};

const safeAreaSingleton = createSafeAreaSingleton();

export default safeAreaSingleton;
